import {
  matchesSearch,
  LookupField,
  createLookupModel,
} from 'src/componentes/filtro/search-drawer/searchDrawerUtils';
import { useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import ToleranciaRiscoLookup from 'src/lookups/ToleranciaRiscoLookup';
import ToleranciaRiscoFaixasLookup from 'src/lookups/ToleranciaRiscoFaixasLookup';
import CollapsibleSection from 'src/componentes/CollapsibleSection';
import { TIPO_ACOMPANHAMENTO_TOLERANCIA_RISCO } from 'src/utils/constants';

const ToleranceSection = ({
  model,
  resources,
  intl,
  searchQuery,
  configuracao,
}) => {
  const fields = [
    {
      label: intl.formatMessage(
        { id: 'labelToleranciaRisco' },
        { risco: resources.risco }
      ),
      id: 'toleranciaRisco',
    },
    {
      label: intl.formatMessage(
        { id: 'labelToleranciaRiscoFaixas' },
        { risco: resources.risco }
      ),
      id: 'toleranciaRiscoFaixas',
    },
  ];

  const matchCount = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  ).length;
  const visibleFields = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  );

  const toleranciaPadrao = configuracao?.faixaToleranciaRiscoPadrao;

  const desabilitarToleranciaRisco =
    configuracao?.tipoAcompanhamentoToleranciaRisco?.id ==
      TIPO_ACOMPANHAMENTO_TOLERANCIA_RISCO.UNICA && toleranciaPadrao != null;

  useEffect(() => {
    if (!desabilitarToleranciaRisco) return;

    model.getModel('toleranciaRisco')?.requestChange([toleranciaPadrao]);
  }, [toleranciaPadrao, desabilitarToleranciaRisco]);

  if (!visibleFields.length && searchQuery) return null;

  return (
    <CollapsibleSection
      title={intl.formatMessage(
        { id: 'labelToleranciaRisco' },
        { risco: resources.risco }
      )}
      forceOpen={matchCount > 0 && searchQuery !== ''}
    >
      <Row>
        {visibleFields.includes(
          fields.find((f) => f.id === 'toleranciaRisco')
        ) && (
          <Col md={12}>
            <LookupField
              Component={ToleranciaRiscoLookup}
              disabled={desabilitarToleranciaRisco}
              clearable
              multi
              highlight={matchesSearch(
                intl.formatMessage(
                  { id: 'labelToleranciaRisco' },
                  { risco: resources.risco }
                ),
                searchQuery
              )}
              model={createLookupModel(
                intl.formatMessage(
                  { id: 'labelToleranciaRisco' },
                  { risco: resources.risco }
                ),
                model.getModel('toleranciaRisco')?.value,
                model.getModel('toleranciaRisco')?.requestChange
              )}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'toleranciaRiscoFaixas')
        ) && (
          <Col md={12}>
            <LookupField
              Component={ToleranciaRiscoFaixasLookup}
              clearable
              multi
              highlight={matchesSearch(
                intl.formatMessage(
                  { id: 'labelToleranciaRiscoFaixas' },
                  { risco: resources.risco }
                ),
                searchQuery
              )}
              model={createLookupModel(
                intl.formatMessage(
                  { id: 'labelToleranciaRiscoFaixas' },
                  { risco: resources.risco }
                ),
                model.getModel('toleranciaRiscoFaixas')?.value,
                model.getModel('toleranciaRiscoFaixas')?.requestChange
              )}
            />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
};

export default ToleranceSection;
